<template lang="pug">
b-modal#addCustom(
  ref="addCustom"
  :title="$t('ui.add_custom')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      template(v-if="customerInfo != null")
        .form-group
          span.badge.badge-info {{ customerInfo.id }}
        b-form-group(:label="$t('ui.phone')" disabled).mb-1
          DebounceInput(
            ref="phone"
            size="sm"
            required
            type="text"
            v-model="phone"
          )
        b-form-group(:label="$t('ui.assignee')" v-if="!isSubAccount").mb-0
          b-form-select(
            size="sm"
            :class="{ 'is-invalid': $v.selectedAsignee.$dirty == true && $v.selectedAsignee.$error == true, 'is-valid': $v.selectedAsignee.$dirty == true && $v.selectedAsignee.$error == false }"
            v-model.trim.lazy="$v.selectedAsignee.$model"
            :disabled="loading"
            )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(v-for="option in subAccountList" :value="option.login_id") {{ option.login_id }}
          ValidateResult(:value="$v.selectedAsignee" :name="$t('ui.assignee')")
        b-form-group(:label="$t('ui.urgency')").mb-0
          b-form-select(
            size="sm"
            :class="{ 'is-invalid': $v.selectedUrgency.$dirty == true && $v.selectedUrgency.$error == true, 'is-valid': $v.selectedUrgency.$dirty == true && $v.selectedUrgency.$error == false }"
            v-model.trim.lazy="$v.selectedUrgency.$model"
            :disabled="loading"
            )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(:value="1") {{ $t('ui.urgency_1') }}
            option(:value="2") {{ $t('ui.urgency_2') }}
            option(:value="3") {{ $t('ui.urgency_3') }}
          ValidateResult(:value="$v.selectedAsignee" :name="$t('ui.urgency')")


    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    customerInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      subAccountList: [],
      phone: "",
      selectedAsignee: "",
      selectedUrgency: ""
    };
  },
  validations() {
    return {
      selectedAsignee: {
        required: requiredIf(function() {
          return !this.isSubAccount
        })
      },
      selectedUrgency: {
        required
      }
    }
  },
  computed: {
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isSubAccount() {
      if (this.getAuthorityRole == 'OWNER_PRI' || this.getAuthorityRole == 'OWNER_SEC') {
          return false;
      } else {
          return true;
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submit();
    },
    submit: function() {
      let url = config.cpiMemberCustomAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        phone: this.customerInfo.phone,
        urgency: this.selectedUrgency
      };

      if(!this.isSubAccount) json.assignee = this.selectedAsignee
      else json.assignee = this.$store.getters.loginId

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addCustom.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_custom", this.feedback.status);
                this.$refs.addCustom.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getSubAccountList: function() {
      let url = config.accountSubListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.$store.getters.loginId,
        page_number: 1,
        page_size: 100
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subAccountList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.subAccountList = []
      this.phone = ""
      this.selectedAsignee = ""
      this.selectedUrgency = ""
      this.$v.$reset();
    },
    shown: function() {
      this.phone = this.customerInfo.phone
      if(!this.isSubAccount)
        this.getSubAccountList();
    }
  }
};
</script>
